import React, { useEffect } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// STYLES
import styles from '../select.module.scss';

// MAIN COMPONENT
const MenuList = props => {

  useEffect(
    () => {
      const list = document.getElementsByClassName('menu-list')[0];
      if (list) list.addEventListener('wheel', e => e.stopPropagation());
      return () => list.removeEventListener('wheel', e => e.stopPropagation());
    },
    []
  )

  return (
    <components.MenuList
      {...props}
      className={clsx('menu-list', styles.menuList, props.className)}
    />
  )
}

// EXPORT
export default MenuList